import React, { createContext, useContext, useState } from 'react';

const AgreementStatusContext = createContext(null);

export const AgreementStatusProvider = ({ children }) => {
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const [hasAcceptedSms, setHasAcceptedSms] = useState(false);

  const value = {
    hasAcceptedTerms,
    hasAcceptedSms,
    setHasAcceptedTerms,
    setHasAcceptedSms,
  };

  return (
    <AgreementStatusContext.Provider value={value}>
      {children}
    </AgreementStatusContext.Provider>
  );
};

export const useAgreementStatus = () => {
  const ctx = useContext(AgreementStatusContext);
  if (!ctx) {
    throw new Error('useAgreementStatus must be used within an AgreementStatusProvider');
  }
  return ctx;
};
